query groupEdit($id: ID!) {
  group(id: $id) {
    id
    name
    icon {
      id
      name
      displayName
    }
    color {
      id
      name
      displayName
    }
    students {
      id
      first
      last
      communicationCount
      mostRecentCommunication
      positivity
      gradeLevel {
        id
        order
        name
      }
    }
  }
}
